import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import { useNavigate } from 'react-router-dom';

import { ReadMeModal } from './ReadMeModal.jsx';
import { fetchAdamo } from '../utils/fetchAdamo.js';


export function ClientDataInputForm() {
  const lightGrayColor ={color: '#d6d4d0'};
  const [readAdatkezeles, setReadAdatkezeles] = useState(false);
  const [readSzerzodes, setReadSzerzodes] = useState(false);
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const [inputValues, setInputValues] = useState({country:'hu', 'kozossegi-adoszam':'', fax:''});

  function handleChange(event){
    let name = event.target.name;
    setInputValues({...inputValues, [name]:event.target.value});
  }

  async function handleSubmit (event) {
    const form = event.target;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
      setValidated(true);
      event.preventDefault();

      if (form.checkValidity() && readAdatkezeles && readSzerzodes) {
        let orderData = {};
        for (let inputName in inputValues) {
          orderData = {...orderData, [inputName]:inputValues[inputName]};
        }

        // console.log(orderData);

        let response = await fetchAdamo("/ajax/kezdolap/send-email", "POST", orderData);
        console.log(response);

        navigate("/email-notification");
      }
  };

   return (    
    <Container>
      <Image src="images/adamo_logo.png" rounded></Image>
      <br/><br/>
      <Row className="justify-content-md-center p-2 bg-light border">
        <Col>
          <h1 className='text-left fw-bold'>Megrendelés</h1> <br/>
          <Image src="images/small_business.jpeg" rounded fluid></Image> <br/><br/>          
          <h3 className="text-left text-warning fw-bold" >ADAMO Digital Business Platform</h3>
          <h3 className="text-left fw-bold" >138 000 Ft + ÁFA havonta</h3>
          <h4 className="text-left fw-bold" style={lightGrayColor}>5 teljes jogú felhasználóval</h4> <br/>                                
          <p className="text-left">Próbálja ki kötöttségek nélkül az Adamo platformot havi díjas konstrukcióban, hűség idő nélkül! A termék akciós ára, az összes használati díjat tartalmaz 5 teljes értékű felhasználói licenccel. Azaz tartalmazza a:</p>
           <ul>
              <li>Teljes értékű felhő szolgáltatásunkat</li>
              <li>Annak üzemeltetését</li>
              <li>Karbantartását</li>
              <li>Verzió és jogszabály követését</li>
              <li>20 Gb tárhelyet</li>
              <li>2 óra termék támogatást és supportot</li>
            </ul>
            <p className="text-left">Ugyanakkor nem tartalmazza a bevezetési, testre szabási és esetlegesen szükséges fejlesztői/tanácsadói díjakat. Kiváló lehetőség, hogy 2 perc alatt hozzájusson és kipróbálja az Adamo digitális platform szolgáltatásait.</p>
        </Col>
        <Col>
        {/* novalidate azért kell, hogy a böngésző saját validátorát kikapcsoljuk */}
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <br/>
            <h4 className="text-secondary text-left fw-bold">alapadatok</h4>
            <InputGroup className="mb-3">
              <InputGroup.Text id="cegnev">cégnév</InputGroup.Text>
              <Form.Control name="cegnev" required placeholder='' onChange={handleChange} value={inputValues.cegnev || ''}/>
              <Form.Control.Feedback type="invalid">Kérem adja meg a cégnevet!</Form.Control.Feedback>
            </InputGroup>

            <Row>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="adoszam">adószám</InputGroup.Text>
                  <Form.Control name="adoszam" required onChange={handleChange} value={inputValues.adoszam  || ''}/>
                  <Form.Control.Feedback type="invalid">Kérem adja meg az adószámát!</Form.Control.Feedback>
                </InputGroup>
              </Col>

              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="kozossegi-adoszam">közösségi adószám</InputGroup.Text>
                  <Form.Control name="kozossegi-adoszam" onChange={handleChange} value={inputValues['kozossegi-adoszam']  || ''}/>
                  <Form.Control.Feedback type="invalid">Kérem adja meg a közösségi adószámát!</Form.Control.Feedback>
                </InputGroup>
              </Col>
            </Row>

            <Row>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="iban">IBAN</InputGroup.Text>
                  <Form.Control name="iban" required onChange={handleChange} value={inputValues['iban'] || ''}/>
                  <Form.Control.Feedback type="invalid">Kérem adja meg az IBAN számát!</Form.Control.Feedback>
                </InputGroup>
              </Col>

              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="cegjegyzekszam">cégjegyzékszám</InputGroup.Text>
                  <Form.Control name='cegjegyzekszam' required onChange={handleChange} value={inputValues['cegjegyzekszam']  || ''}/>
                  <Form.Control.Feedback type="invalid">Kérem adja meg a cégjegyzékszámát!</Form.Control.Feedback>
                </InputGroup>
              </Col>
            </Row>

            <Row>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="phone">telefon</InputGroup.Text>
                  <Form.Control name='phone' required onChange={handleChange} value={inputValues['phone']  || ''}/>
                  <Form.Control.Feedback type="invalid">Kérem adja meg a telefoszámát!</Form.Control.Feedback>
                </InputGroup>
              </Col>

              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="fax">fax</InputGroup.Text>
                  <Form.Control name='fax' onChange={handleChange} value={inputValues['fax']  || ''}/>
                </InputGroup>
              </Col>
            </Row>              

            <InputGroup className="mb-3">
              <InputGroup.Text id="email">e-mail cím</InputGroup.Text>
              <Form.Control name='email' required type="email" id="email-control" aria-describedby="basic-addon3" onChange={handleChange} value={inputValues['email']  || ''}/>
              <Form.Control.Feedback type="invalid">Kérem adja meg az e-mail címét!</Form.Control.Feedback>
            </InputGroup>

            
            <h4 className="text-secondary text-left fw-bold">számlázási cím</h4>
            <Row>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="country"> ország</InputGroup.Text>
                  <Form.Select name='country' required aria-label="Ország választás" onChange={handleChange} value={inputValues['country']  || 'hun'}>
                    <option value="hu">Magyarország</option>
                    <option value="usa">Amerikai Egyesült Államok</option>
                    <option value="uk">Nagy-Brittania</option>              
                    <option value="at">Ausztria</option>
                    <option value="de">Németország</option>
                    <option value="cz">Csehország</option>
                    <option value="sk">Szlovákia</option>
                    <option value="pl">Lengyelország</option>
                    <option value="ua">Ukrajna</option>
                    <option value="ro">Románia</option>
                    <option value="srb">Szerbia</option>
                    <option value="hr">Horvátország</option>
                    <option value="slo">Szlovénia</option>
                  </Form.Select>
                </InputGroup>
              </Col>

              <Col>
                <InputGroup className="mb-3">
                    <InputGroup.Text id="zip-code">irányítószám</InputGroup.Text>
                    <Form.Control name='zip-code' required onChange={handleChange} value={inputValues['zip-code']  || ''}/>
                    <Form.Control.Feedback type="invalid">Kérem adja meg az irányítószámát!</Form.Control.Feedback>
                </InputGroup>
              </Col>
            </Row>

            <InputGroup className="mb-3">
              <InputGroup.Text id="city">telepules</InputGroup.Text>
              <Form.Control name='city' required onChange={handleChange} value={inputValues['city']  || ''}/>
              <Form.Control.Feedback type="invalid">Kérem adja meg a települést!</Form.Control.Feedback>
            </InputGroup>

            <InputGroup className="mb-3">
              <InputGroup.Text id="address">utca, hsz</InputGroup.Text>
              <Form.Control name='address' required onChange={handleChange} value={inputValues['address']  || ''}/>
              <Form.Control.Feedback type="invalid">Kérem adja meg az az utca nevet és a házszámot!</Form.Control.Feedback>
            </InputGroup>

            <h4 className="text-secondary text-left fw-bold">kapcsolattartó</h4>
            <Row>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="vezeteknev">vezetéknév</InputGroup.Text>
                  <Form.Control name='vezeteknev' required onChange={handleChange} value={inputValues['vezeteknev']  || ''}/>
                  <Form.Control.Feedback type="invalid">Kérem adja meg a vezetéknevét!</Form.Control.Feedback>
                </InputGroup>              
              </Col>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="keresztnev">keresztnév</InputGroup.Text>
                  <Form.Control name='keresztnev' required onChange={handleChange} value={inputValues['keresztnev']  || ''}/>
                  <Form.Control.Feedback type="invalid">Kérem adja meg a keresztnevét!</Form.Control.Feedback>
                </InputGroup>              
              </Col>              
            </Row>

            <Row>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="contact-email">e-mail</InputGroup.Text>
                  <Form.Control name='contact-email' required type="email" onChange={handleChange} value={inputValues['contact-email']  || ''}/>
                  <Form.Control.Feedback type="invalid">Kérem adja meg a kapcsolattartó e-mail címét!</Form.Control.Feedback>
                </InputGroup>              
              </Col>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="contact-phone">telefonszám</InputGroup.Text>
                  <Form.Control name='contact-phone' required onChange={handleChange} value={inputValues['contact-phone']  || ''}/>
                  <Form.Control.Feedback type="invalid">Kérem adja meg a kapcsolattartó telefoszámát!</Form.Control.Feedback>
                </InputGroup>              
              </Col>              
            </Row>            
            
            <h6 className="text-left fw-bold text-danger">A visszaigazoló e-mail-eket a kapcsolattartó e-mail címére fogjuk kiküldeni.</h6>
            <h6 className="text-left fw-bold"> Kérem olvassa majd fogadja el az Adatkezelési irányelveket és a Szerződési feltételeket!</h6>
            <ReadMeModal setRead={setReadAdatkezeles} title="Adatkezelési irányelvek" buttonText="Adatkezelési irányelvek" modalText="LLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."/> <br/><br/>
            <ReadMeModal setRead={setReadSzerzodes} title="Szerződési feltételek" buttonText="Szerződési feltételek" modalText="LLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."/> <br/><br/>

            <InputGroup className="mb-3">
              {readAdatkezeles ?             
                  <Form.Check required type="checkbox" label="Az adatkezelésre vonatkozó irányelveket elolvastam és hozzájárulok a megadott adataim kezeléséhez" id={`adatkezeles-checkbox`}/>                            
                : <Form.Check disabled required type="checkbox" label="Az adatkezelésre vonatkozó irányelveket elolvastam és hozzájárulok a megadott adataim kezeléséhez" id={`adatkezeles-checkbox`}/>                                            
              }
            </InputGroup>
            <InputGroup className="mb-3">        
              {readSzerzodes ?
                    <Form.Check required type="checkbox" label="A szerződési feltételeket elolvastam és elfogadom" id={`szerzodes-checkbox`}/>
                  : <Form.Check disabled required type="checkbox" label="A szerződési feltételeket elolvastam és elfogadom" id={`szerzodes-checkbox`}/>
              }                        
            </InputGroup>      

            <div className="d-grid gap-2">
              <Button variant="warning" type="submit">Fiók létrehozása és fizetés</Button>
            </div>

          </Form>
        </Col>
      </Row>
    </Container>
  )
}
